import statePromise from 'src/lib/statePromise';
import { getTeamChatMessages } from './team.sequence';
import NotificationBadge from 'src/game/components/shared/NotificationBadge';

/**
 * Updates a badge with the number of unread messages in the team chat.
 * @param badge - The badge to update.
 * @param persist - Whether to wait for the user to join a team if they are not in one.
 * @returns
 */
export async function updateTeamNotificationBadge(
  stop: VoidFunction,
  badge: NotificationBadge,
  persist = false,
) {
  const cacheAPI = getTeamChatMessages();

  // Not in team.
  if (!cacheAPI) {
    badge.hide();

    // Wait for the user to join a team if persisting.
    if (persist) {
      await statePromise(() => !!getTeamChatMessages());
      void updateTeamNotificationBadge(stop, badge);
      return;
    }

    // Break the loop if not persisting.
    stop();
    return;
  }

  try {
    // Get unread messages count from cache.
    const { unreadMessagesCount, unreadRequestCount } = await cacheAPI.get();
    if (unreadMessagesCount === 0) {
      badge.hide();
      return;
    }

    badge.show();

    if (unreadRequestCount) {
      badge.updateStyle('red');
      badge.setText(unreadRequestCount.toString());
    } else {
      badge.updateStyle('green');
      badge.setText(unreadMessagesCount.toString());
    }
  } finally {
    await getTeamChatMessages()?.waitForRefresh();
  }
}
